import React from 'react';
import { observer } from 'mobx-react-lite';
import DatePickerLib from 'react-datepicker';
import { DateInputWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';
import { InputError, InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

type DatePickerType = {
    id: string;
    label: string;
    dateState: FormInputState<string, string>;
    selected: Date | null;
    isEmpty: boolean;
    disabled?: boolean;
    onChange: (date: Date | null) => void;
    onBlur: (date: React.FocusEvent<HTMLInputElement>) => void;
};

export const DatePickerComponent = observer(
    ({ id, label, dateState, selected, isEmpty, disabled = false, onChange, onBlur }: DatePickerType) => {
        const { errorsForView } = dateState;
        return (
            <DateInputWrapper isEmpty={isEmpty}>
                <InputLabel isEmpty={isEmpty}>{label}</InputLabel>
                <DatePickerLib
                    id={id}
                    disabled={disabled}
                    selected={selected}
                    onChange={onChange}
                    onBlur={onBlur}
                    showTimeSelect
                    timeFormat='HH:mm'
                    timeIntervals={15}
                    timeCaption='time'
                    dateFormat='MMMM d, yyyy h:mm aa'
                />
                {errorsForView.length > 0 ? <InputError>{errorsForView}</InputError> : null}
            </DateInputWrapper>
        );
    }
);
